/* Garage theme — JS ligero, sin dependencias */
(function () {
  'use strict';

  /* Menú móvil */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    var toggles = document.querySelectorAll('[data-menu-toggle]');
    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    }
    toggles.forEach(function (t) { t.addEventListener('click', function () { setOpen(!drawer.classList.contains('is-open')); }); });
    drawer.querySelectorAll('[data-menu-close]').forEach(function (el) { el.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  /* Galería de producto */
  function initGallery(root) {
    var slides = root.querySelectorAll('[data-media-id]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    function show(id) {
      slides.forEach(function (s) { s.classList.toggle('is-hidden', s.getAttribute('data-media-id') !== String(id)); });
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(id) ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-thumb')); }); });
    root.showMedia = show;
  }

  /* Cantidad */
  function initQty(scope) {
    scope.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* Paquetes (1 o 2 unidades): sincroniza cantidad y texto del botón */
  function initBundle(section) {
    var radios = section.querySelectorAll('[data-bundle-qty]');
    if (!radios.length) return;
    function sync() {
      var checked = section.querySelector('[data-bundle-qty]:checked');
      var qty = checked ? checked.getAttribute('data-bundle-qty') : '1';
      var total = checked ? checked.getAttribute('data-bundle-total') : '';
      var input = section.querySelector('[data-qty-input]');
      var btn = section.querySelector('[data-buy-button]');
      if (input) input.value = qty;
      if (btn && !btn.disabled) {
        var tpl = btn.getAttribute('data-label') || 'Agregar [n]';
        btn.textContent = tpl.replace('[n]', qty) + ' — ' + total;
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();
  }

  /* Carrusel "en movimiento" */
  function initReels(root) {
    root.querySelectorAll('[data-reels]').forEach(function (reels) {
      if (reels.getAttribute('data-ready')) return;
      reels.setAttribute('data-ready', '1');
      var items = Array.prototype.slice.call(reels.querySelectorAll('[data-reel-item]'));
      if (!items.length) return;
      var n = items.length, active = Math.floor(n / 2), timer = null, playing = reels.getAttribute('data-autoplay') === 'true';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) playing = false;
      var toggle = reels.querySelector('[data-reel-toggle]');

      function render() {
        items.forEach(function (el, i) {
          var off = i - active;
          if (off > n / 2) off -= n;
          if (off < -n / 2) off += n;
          var abs = Math.abs(off);
          el.style.setProperty('--o', off);
          el.style.setProperty('--a', abs);
          if (abs > 2) el.setAttribute('data-hidden', ''); else el.removeAttribute('data-hidden');
          var v = el.querySelector('video');
          if (v) { if (off === 0) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }
        });
      }
      function go(d) { active = (active + d + n) % n; render(); }
      function start() { stop(); if (playing) timer = setInterval(function () { go(1); }, 4200); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      items.forEach(function (el, i) { el.addEventListener('click', function () { active = i; render(); start(); }); });
      var prev = reels.querySelector('[data-reel-prev]'), next = reels.querySelector('[data-reel-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); start(); });
      if (next) next.addEventListener('click', function () { go(1); start(); });
      function label() { if (toggle) toggle.textContent = playing ? 'Pausar' : 'Reproducir'; }
      if (toggle) toggle.addEventListener('click', function () { playing = !playing; label(); start(); });
      label(); render(); start();
    });
  }

  /* Muro de reseñas: "Ver más" */
  function initReviews(root) {
    root.querySelectorAll('[data-reviews]').forEach(function (box) {
      var limit = parseInt(box.getAttribute('data-visible'), 10) || 8;
      var cards = Array.prototype.slice.call(box.querySelectorAll('[data-review]'));
      var more = box.querySelector('[data-reviews-more]');
      if (cards.length <= limit || !more) return;
      cards.forEach(function (c, i) { if (i >= limit) c.hidden = true; });
      more.hidden = false;
      more.addEventListener('click', function () {
        cards.forEach(function (c) { c.hidden = false; });
        more.hidden = true;
      });
    });
  }

  /* Producto: variantes + sección dinámica */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var gallery = section.querySelector('[data-gallery]');
    if (gallery) initGallery(gallery);
    initQty(section);

    function selectedOptions() {
      var opts = [];
      section.querySelectorAll('[data-option-position]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts[parseInt(group.getAttribute('data-option-position'), 10) - 1] = checked ? checked.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function swap(newDoc, selector) {
      var next = newDoc.querySelector(selector);
      var current = section.querySelector(selector);
      if (next && current) current.replaceWith(next);
    }

    function onChange() {
      var variant = findVariant(selectedOptions());
      if (!variant) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media && gallery && gallery.showMedia) gallery.showMedia(variant.featured_media.id);

      var sectionId = section.getAttribute('data-section-id');
      fetch(url.pathname + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-price-block]', '[data-buy-block]', '[data-bundle-block]', '[data-sticky-bar]', '[data-stock-block]'].forEach(function (sel) { swap(doc, sel); });
          initQty(section);
          initBundle(section);
        });
    }
    section.querySelectorAll('[data-option-position] input').forEach(function (i) {
      i.addEventListener('change', function () {
        var label = i.closest('[data-option-position]').querySelector('[data-selected-label]');
        if (label) label.textContent = i.value;
        onChange();
      });
    });
    initBundle(section);

    /* Barra fija en móvil: aparece al pasar el botón de compra */
    var bar = section.querySelector('[data-sticky-bar]');
    var buy = section.querySelector('[data-buy-block]');
    if (bar && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var current = section.querySelector('[data-sticky-bar]');
        if (current) current.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(buy);
    }
  }

  /* Orden de colección */
  function initSort() {
    var sort = document.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', function () { sort.form.submit(); });
  }

  /* Productos relacionados (API de recomendaciones) */
  function initRelated(root) {
    root.querySelectorAll('[data-related-url]').forEach(function (el) {
      if (el.querySelector('.grid')) return;
      fetch(el.getAttribute('data-related-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-related-root]');
          if (next && next.innerHTML.trim().length) el.innerHTML = next.innerHTML;
        });
    });
  }

  /* Aparición suave al hacer scroll */
  var revealObserver = null;
  function initReveal(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    var selector = [
      '.section:not([data-product-section]) .container > *',
      '.card', '.multicolumn__item', '.steps__item', '.benefit', '.review',
      '.collection-card', '.showcase__item', '.acc', '.iwt__media', '.iwt__content > *',
      '.product__info > *:not([data-buy-block])',
      '.vy-split__text', '.vy-split__media', '.vy-cards__head', '.vy-card', '.vy-faq__inner', '.vy-reviews__wall', '.vy-reels__title'
    ].join(',');
    root.querySelectorAll(selector).forEach(function (el, i) {
      if (el.classList.contains('reveal') || el.closest('.hero:not(.story)')) return;
      el.classList.add('reveal');
      var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--reveal-delay', (Math.min(siblings, 6) * 70) + 'ms');
      revealObserver.observe(el);
    });
  }

  /* Zoom de galería siguiendo el cursor */
  function initZoom(root) {
    root.querySelectorAll('.gallery__main').forEach(function (box) {
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        box.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        box.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  /* Sombra del encabezado al hacer scroll */
  function initHeaderShadow() {
    var header = document.querySelector('.header');
    if (!header) return;
    function onScroll() { header.classList.toggle('is-scrolled', window.scrollY > 8); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initSort();
    initReveal(document);
    initZoom(document);
    initHeaderShadow();
    initReels(document);
    initReviews(document);
    initRelated(document);
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initQty(document);
  });

  /* Editor de temas: reinicializar al recargar una sección */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    root.querySelectorAll('[data-product-section]').forEach(initProduct);
    initQty(root);
    initReveal(root);
    initZoom(root);
    initReels(root);
    initReviews(root);
  });
})();
